import { render, staticRenderFns } from "./InquiryRetirement.vue?vue&type=template&id=709a9d26&"
import script from "./InquiryRetirement.vue?vue&type=script&lang=ts&"
export * from "./InquiryRetirement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709a9d26')) {
      api.createRecord('709a9d26', component.options)
    } else {
      api.reload('709a9d26', component.options)
    }
    module.hot.accept("./InquiryRetirement.vue?vue&type=template&id=709a9d26&", function () {
      api.rerender('709a9d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/InquiryRetirement.vue"
export default component.exports